import { useDialogs } from "@/lib/dialogs";
import { AyndriLogo } from "@/components/brand/AyndriLogo";

const SIDE = ["⌂  Home", "▦  Events", "♙  Clients", "▤  Venues", "◫  Suppliers", "♧  Partners", "◷  Calendar", "☰  Reports", "⚙  Settings"];
const STATS = [["Active events", "12"], ["Client inquiries", "48"], ["Bookings", "26"], ["Pipeline", "₹ 1.2Cr"]];
const ACTS = [["A", "New inquiry · Hyderabad wedding", "CRM lead · demo activity"], ["V", "Venue shortlist submitted", "Event 360 · demo activity"], ["S", "Supplier quotation received", "Procurement · demo activity"]];

export const LaptopMock = () => (
  <div className="laptop" role="img" aria-label="Illustrative Salesforce-inspired Event Management dashboard" data-testid="hero-dashboard-preview">
    <div className="lap-top"><AyndriLogo variant="compact" tone="dark" markSize={20} className="mini" /><span className="lap-search">⌕ Search existing events, CRM and suppliers...</span><span>◉</span><span className="avatar">SA</span></div>
    <div className="lap-body">
      <div className="lap-side">{SIDE.map((s, i) => <div key={s} className={`lap-item ${i === 0 ? "active" : ""}`}>{s}</div>)}</div>
      <div className="lap-content">
        <h3>Welcome to Ayndri, Sarah</h3>
        <div className="sub">Your existing enterprise workspace · UI demonstration</div>
        <div className="mock-stats">{STATS.map(([l, v]) => <div key={l} className="mock-stat"><span>{l}</span><strong>{v}</strong><small>Illustrative</small></div>)}</div>
        <div className="mock-detail">
          <div className="mock-box"><h4>Recent activity <span style={{ color: "#1a73cc" }}>View all</span></h4>
            {ACTS.map(([a, b, s]) => <div key={b} className="act"><div className="avatar">{a}</div><div><b>{b}</b><span>{s}</span></div></div>)}
          </div>
          <div className="mock-box"><h4>Pipeline overview</h4><strong style={{ fontSize: 13, color: "#0d4c9a" }}>₹ 1.2Cr</strong>
            <div className="bars">{[18, 34, 45, 55, 67, 89].map((h) => <span key={h} style={{ height: `${h}%` }} />)}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const PhoneMock = () => {
  const open = useDialogs();
  return (
    <div className="phone" data-testid="hero-mobile-inquiry-preview">
      <span className="phone-notch" />
      <div className="phone-inner">
        <div className="phone-head"><AyndriLogo variant="compact" tone="dark" markSize={16} className="mini" /><span>☰</span></div>
        <h4 style={{ fontSize: 10, margin: "10px 0 2px", fontWeight: 800 }}>Plan your event</h4>
        <span style={{ color: "#6e8197" }}>Simple multilingual inquiry</span>
        <img src="/assets/img1.jpg" alt="Event venue" />
        <div className="phone-input">Event type<br /><b>Wedding ▾</b></div>
        <div className="phone-input">Location<br /><b>Hyderabad ▾</b></div>
        <div className="phone-input">Guests<br /><b>250 ▾</b></div>
        <button className="phone-btn" onClick={() => open("inquiry", { prefill: { type: "Wedding", city: "Hyderabad", guests: "250" } })} data-testid="phone-mock-next-button">Next →</button>
      </div>
    </div>
  );
};
